export const countriesAPI = {
    async upload () {
        let resp = await fetch("/api/countries").catch(e => console.log(e))
        
        let error = null
        let body = await resp
            .json()
            .catch(e => error = "something_went_wrong");

        if(error) {
            return {
                ok: false,
                err: error
            }
        }

        if(!body || !body.countries) {
            return null
        }
        return {
            ok: true, 
            countries: body.countries
        }
    },
}